/**
 * Size chart modal.
 *
 * Thin wrapper over the native <dialog>: showModal() already gives us the
 * backdrop, Escape to close, focus trapping and inertness of the page behind.
 * All this adds is the open/close wiring and click-outside-to-dismiss.
 */
class SrnSizeChart extends HTMLElement {
  connectedCallback() {
    if (this.dialog) return; // guard against Horizon re-running on morph

    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.querySelector('[data-srn-open]')?.addEventListener('click', () => {
      this.dialog.showModal();
    });

    this.querySelector('[data-srn-close]')?.addEventListener('click', () => {
      this.dialog.close();
    });

    // The dialog element fills the viewport, so a click that lands on it
    // rather than on its contents is a click on the backdrop.
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }
}

if (!customElements.get('srn-size-chart')) {
  customElements.define('srn-size-chart', SrnSizeChart);
}
